import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep3_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F62.css';
import backIcon2 from '../../../Assests/backIcon2.svg'

function Frame62() {
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);

    useEffect(() => {

    }, [])

    
        return (
            <div className="F62_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F62_entryBox">
                    <div className="F62_paragraph">
                        {language === 'english' ?
                            <p className="F62_paragraphEnglish">Girls were slowly getting calm and seemed like agreeing and understanding what Saira was telling them. One of them said, you might be right Saira, but I feel menstruation is a curse on women and we are punished for a whole week every month</p>
                            :
                            <p className="F62_paragraphUrdu">لڑکیوں کو اب آہستہ آہستہ سائرا کی باتیں سمجھ آرہی تھیں۔ ان میں سے ایک لڑکی سائرا سے بولی کہ تم ٹھیک کہہ رہی ہو گی لیکن مجھے ایسا لگتا ہے کہ جیسے ماہواری کوئی بددعا ہو اور آپ کو پورا ہفتہ سزا مل رہی ہو۔</p>
                        }
                    </div>

                    <div className="F62_timeline">
                        <div className='F62_timelineBar'>
                            <div className='F62_timelineFill'></div>
                            <span className='F62_timelineText'>10/14</span>
                        </div>
                    </div>

                    <div className="F62_nextFrames">
                        <div className="F62_nextFrame1"></div>
                        <div className="F62_nextFrame2"></div>
                        <div className="F62_nextFrame3"></div>
                    </div>

                    <div className='F62_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep3_lastVisitFrame(10)) }} className='F62_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    
}

export default Frame62;